import { ICreateAndUpdateMunicipality } from "../../../types/common.interface";
import { ICreateAndUpdateGovernmentShip } from "../../../types/govenmentShip.interface";
import customAxios from "../../customAxios";
import { UPDATE_GOVERNMENT_SHIP } from "../../routes";

const updateGovernmentShip = async (
  formData: ICreateAndUpdateGovernmentShip
) => {
  try {
    return (
      await customAxios.put(UPDATE_GOVERNMENT_SHIP + `/${formData._id}`, {
        ...formData,
        province: formData.province?._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ GOVERNMANT_SHIP: error });
    return false;
  }
};

export default updateGovernmentShip;
